// How long a mastermind's own words can be, in characters: a member's goal, a note on an action and a
// win (its words and its "more about it"), and an action Adam sets. They're every mastermind's, as the
// database's checks and staff functions are, not the Accelerator's alone. The same numbers as the database's
// checks and staff functions (supabase/migrations/20261011120000_accelerator_move.sql), widened on 11 Oct
// 2026 so every word members wrote on the old site comes across whole (Adam's decision for the
// Accelerator's move). Every form on the member's pages and in Masterminds holds to these, and the
// lines that name a limit read them, so a change is 1 line here and 1 migration.
export const LIMITS = Object.freeze({
  goal: 12000,
  action: 500,
  note: 3000,
  winTitle: 400,
  winDetail: 2000,
})

// A limit as the words write it: 12,000
export const limitWords = n => n.toLocaleString('en-GB')
